
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Hardware1 from '../../images/electricity_hardware1.gif';

import {
  ProjectWrapper,
  ProjectContainer,
  ProjectCard
} from "./projectStyles";

const projectData = {
  EdgeTechSection: [
    {
      title: "Electricity Monitoring System",
      img: [
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1772091382/Untitled-1_qy2eyo.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1772114767/electricity_mon1_miel0u.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1772210626/ui_electricity_click_bwdhkk.gif",
        Hardware1
      ],
      link: "https://gitlab.com/albiemerporte/orio-zeus-electricity-monitoring-system"
    },
    {
      title: "Authenticator Device",
      img: [
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1778105578/enclosurefinal_med0cv.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1778032612/New_Project_a5doy3.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1778029467/enclosure1_w29w8w.gif",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1778068957/enclosure2_ttioiq.gif",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1778223034/Untitled_pmf4ne.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1778223692/pcb1_maw4gi.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1778223853/pcb2_uwax3q.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1778231215/pcb_vtx4qi.gif" 
      ]
    },
    {
      title: "EMS Schematic & PCB",
      img: [
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1772292835/eletricalschematic_nayvxf.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1772293400/EMSPCB_bjxbor.png"
      ],
      link: "https://gitlab.com/albiemerporte/orio-zeus-electricity-monitoring-system"
    },
    {
      title: "Gas Leak Detection System",
      img: "https://res.cloudinary.com/dywqyzge2/image/upload/v1772192626/Untitled_Project_ppse33.gif",
      link: "https://gitlab.com/albiemerporte/gas-leask-detection-system"
    },
    {
      title: "DIY PCB Audio System",
      img: ["https://res.cloudinary.com/dywqyzge2/image/upload/v1772291987/pcb1_pstntc.png",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772292493/schematic1_srgvza.png"],
      link: "https://gitlab.com/albiemerporte/library-management-system-pure-python3"
    }
  ],
  DesktopGuiToolsSection: [
    {
      title: "SingLobby Videoke Software",
      img: ["https://res.cloudinary.com/dywqyzge2/image/upload/v1772080206/Screenshot_2026-02-26_112122_goglhb.png",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772157597/front_with_menu_eaubpn.png",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772158753/Screenshot_2026-02-27_101719_v3irfb.png"],
      link: "https://www.singlobby.com/#download"
    },
    {
      title: "Media Marketing Management System",
      img: "https://res.cloudinary.com/dywqyzge2/image/upload/v1772211830/media_marketing1_yqxzfd.gif",
      link: "https://gitlab.com/albiemerporte/library-management-system-pure-python3"
    },
    {
      title: "Library Management System",
      img: ["https://res.cloudinary.com/dywqyzge2/image/upload/v1772011068/library_lzi8hi.png",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772163814/Library_Management_System_nkfvqk.png",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772170916/passpy_y4m2ul.png"],
      link: "https://gitlab.com/albiemerporte/library-management-system-pure-python3"
    },
    {
      title: "Hybrid Password Manager",
      img: ["https://res.cloudinary.com/dywqyzge2/image/upload/v1772064689/hybrid_password_eoqwxa.png",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772162604/Screenshot_2026-02-26_075552_rq5ek6.png",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772162868/Screenshot_2026-02-26_080209_hxyjng.png",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772163229/Screenshot_2026-02-26_075943_qcvx7v.png",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772163443/Screenshot_2026-02-26_080342_fvfox5.png"],
      link: "https://gitlab.com/albiemerporte/Hybrid-Password-Manager"
    }
  ],
  FrameworksSection: [
    {
      title: "Karaoke Web",
      img: [
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1790108412/ui1_xbjpgb.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1790108610/ui2_epohac.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1790110860/ui3_lsgcue.png"
      ],
      link: "https://www.singlobby.com/karaoke"
    },
    {
      title: "Karaoke Composer",
      img: [
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1790138062/composer1_e3k6ea.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1790138457/composerui2_gunuy1.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1790138469/composerui3_xbbgzd.png"
      ],
      link: "https://www.singlobby.com/composer"
    },
    {
      title: "Portfolio Website",
      img: [
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1772008110/portfolio_zjhunv.jpg",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1772156696/portfolio_aofwuw.png",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1772155405/portfolio_project_rc5kxe.png"
      ],
      link: "https://albiemer.singlobby.com"
    },
    {
      title: "SingLobby Landing Page",
      img: ["https://res.cloudinary.com/dywqyzge2/image/upload/v1772008707/singlobby_shr99a.jpg",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772155688/singlobby_bode_dbnyah.png"],
      link: "https://www.singlobby.com"
    },
    {
      title: "Jesus Light House",
      img: ["https://res.cloudinary.com/dywqyzge2/image/upload/v1772083171/jesus_lighthouse_xbmmyj.png",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772156333/Screenshot_2026-02-26_125924_culr9r.png",
            "https://res.cloudinary.com/dywqyzge2/image/upload/v1772156349/about_us_hpcmgv.png"],
      link: "https://albiemer.singlobby.com/jesus_lighthouse.html"
    }
  ],
  MLSection: [
    {
      title: "Smart Doorlock Facial Recognition",
      img: [
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1772209755/smart_door1_jhzmkk.gif",
        "https://res.cloudinary.com/dywqyzge2/image/upload/v1772239065/dark_test_flseza.gif"
      ],
      link: "https://gitlab.com/albiemerporte/smart-door-lock"
    },
    {
      title: "Face Detection",
      img: "https://res.cloudinary.com/dywqyzge2/image/upload/v1772210440/smart_door2_nd70ni.gif",
      link: ""
    }
  ]
};

export default function ProjectsSection({ category }) {
  const projects = projectData[category] || [];

  // Gamitin ang parehong logic sa PortfolioSections mo
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sliderSettings = {
    arrows: true,     // No arrows sa mobile para mas clean
    autoplay: !isMobile,   // ETO ANG SOLUSYON: False agad pag mobile
    
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768,   // Mobile breakpoint
        settings: {
          autoplay: false, // Eto ang "killer switch" para sa mobile
          arrows: false,   // Opsyonal: Mas maganda swipe-only sa mobile
          dots: false       // Panatilihin ang dots para alam nilang may ibang images
        }
      }
    ]
  };

  return (
    <ProjectWrapper>
      {/* <h5>Projects</h5> ,*/}
      <ProjectContainer>
        {projects.map((proj, idx) => (
          <ProjectCard key={idx}>
            <h5>{proj.title}</h5>
            <a href={proj.link} target="_blank" rel="noreferrer">
              {Array.isArray(proj.img) && proj.img.length > 1 ? (
                <Slider {...sliderSettings}>
                  {proj.img.map((image, i) => (
                    <div key={i} className="slider-image-container">
                      <img src={image} alt={proj.title} />
                    </div>
                  ))}
                </Slider>
              ) : (
                <div className="slider-image-container">
                  <img src={Array.isArray(proj.img) ? proj.img[0] : proj.img} alt={proj.title} />
                </div>
              )}
            </a>
          </ProjectCard>
        ))}
      </ProjectContainer>
    </ProjectWrapper>
  );
}
